export const OfferUnsubscribeErrorViewUat = {
  message: 'offerUnsubscribeError.message',
}
